export class City {
    _id: string;
    name: string;
    region: string;
    createdDate: Date;
}